<div class="SLV2-main-wrapper" *ngIf="subjectName">
    <div class="col-xl-2 col-md-3" *ngIf="selfLearnService.isFromLearn()">
        <app-sidebar-learn></app-sidebar-learn>    
    </div>
    <div class="SLV2-body-section">
        <app-subject-topic-header [bannerSubject]="subjectName" [isTopicsHeader]="false" [bannerData]="headerBannerdata" [SelctedBookName]="bookName"></app-subject-topic-header>
        <div class="SLV2-body-col-wrap-section">

            <div class="SLV2-body-section">

                <div class="SLV2-section-wrap resume-learning" *ngIf="resumeVideoData">
                    <app-resume-learning-card [data]="resumeVideoData" [isFromHomeScreen]=false  [subjectData]="subjectData"></app-resume-learning-card>
                </div>

                <div class="SLV2-section-wrap" *ngIf="chapterdata?.length > 0">
                    <div class="SLV2-section-head-section">
                        <div class="SLV2-section-heading-wrap">
                            <h3 class="SLV2-section-heading">All Chapters</h3>
                            <!-- <h4 class="SLV2-section-subheading">6 topics, 5h 39m Total Duration</h4> -->
                        </div>
                    </div>

                    <ol class="SLV2-chapter-topic-list" [ngClass]="{'expanded' : chapterViewMoreStatus}">
                        <li *ngFor="let chapter of chapterdata">
                            <!-- <app-topic-card [cardSubject]="subjectName" [topicData]="topic"></app-topic-card> -->
                            <app-chapter-card [cardSubject]="subjectName"
                             [isUserSubcribed]="isUserSubscribed" (click)="navigateTOChapterPage(chapter)" [chapterData]="chapter"></app-chapter-card>
                        </li>
                    </ol>

                    <!-- <div class="SLV2-section-action-area subject-section" *ngIf="chapterdata.length > 5">
                        <button class="SLV2-subject-view-more-btn" [ngClass]="{'expanded' : chapterViewMoreStatus}" (click)="chapterViewMore()">
                            <ng-container *ngIf="!chapterViewMoreStatus">view more</ng-container>
                            <ng-container *ngIf="chapterViewMoreStatus">view less</ng-container>
                            <img src="assets/img/profile-drop-down-arrow.svg" />
                        </button>
                    </div> -->
                    


                </div>
                <ng-container *ngIf="chapterdata?.length <= 0 && !isLoading">
                    <app-no-content-card></app-no-content-card>
                </ng-container>               
            </div>


            <!-- <app-ads-sidebar></app-ads-sidebar> -->
        </div>
    </div>
</div>
